// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const observatory = defineModel({
  id: "observatory",
  batchId: "future",
  name: "Observatory",
  tags: ["building","observatory","low-poly","age-of-mcp","future"],
  summary: "Studies the sky — a research and prestige building.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.5,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(0.94, 0.14, 0.94), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(0.94, 0.14, 0.94), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.46, 0.5, 0.18, 12), color: "#9a9486", position: [0, 0.23, 0] },
      { geometry: new THREE.CylinderGeometry(0.4, 0.4, 0.55, 12), color: "#b9b3a4", position: [0, 0.415, 0] },
      { geometry: new THREE.CylinderGeometry(0.42, 0.42, 0.05, 12), color: "#9a9486", position: [0, 0.503, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.95, 4), color: "#6b4a26", position: [-0.39, 0.475, -0.39] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.95, 4), color: "#6b4a26", position: [0.39, 0.475, -0.39] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.95, 4), color: "#6b4a26", position: [-0.39, 0.475, 0.39] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.95, 4), color: "#6b4a26", position: [0.39, 0.475, 0.39] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(0.94, 0.14, 0.94), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.46, 0.5, 0.18, 12), color: "#9a9486", position: [0, 0.23, 0] },
      { geometry: new THREE.CylinderGeometry(0.4, 0.4, 1.1, 12), color: "#b9b3a4", position: [0, 0.69, 0] },
      { geometry: new THREE.CylinderGeometry(0.42, 0.42, 0.05, 12), color: "#9a9486", position: [0, 0.866, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.6, 4), color: "#6b4a26", position: [-0.39, 0.8, -0.39] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.6, 4), color: "#6b4a26", position: [0.39, 0.8, -0.39] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.6, 4), color: "#6b4a26", position: [-0.39, 0.8, 0.39] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.6, 4), color: "#6b4a26", position: [0.39, 0.8, 0.39] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(0.94, 0.14, 0.94), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.46, 0.5, 0.18, 12), color: "#9a9486", position: [0, 0.23, 0] },
      { geometry: new THREE.CylinderGeometry(0.4, 0.4, 1.1, 12), color: "#b9b3a4", position: [0, 0.69, 0] },
      { geometry: new THREE.CylinderGeometry(0.42, 0.42, 0.05, 12), color: "#9a9486", position: [0, 0.866, 0] },
      { geometry: new THREE.CylinderGeometry(0.42, 0.42, 0.08, 12), color: "#9a9486", position: [0, 1.28, 0] },
      { geometry: new THREE.SphereGeometry(0.42, 12, 8, 0, 6.283185, 0, 1.570796), color: "#d8d2c2", position: [0, 1.32, 0], scale: [1, 0.8, 1] },
      { geometry: new THREE.BoxGeometry(0.14, 0.42, 0.12), color: "#2a2e33", position: [0, 1.44, 0.32] },
      { geometry: new THREE.CylinderGeometry(0.07, 0.08, 0.6, 10), color: "#5a5f66", position: [0, 1.54, 0.42], rotation: [0.9, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.085, 0.085, 0.05, 10), color: "#3c4046", position: [0, 1.7, 0.55], rotation: [0.9, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.06, 0.05, 10), color: "#3c4046", position: [0, 1.38, 0.29], rotation: [0.9, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.24, 0.4, 0.06), color: "#4a3520", position: [0, 0.34, 0.41] },
      { geometry: new THREE.CylinderGeometry(0.12, 0.12, 0.06, 8, 1, false, 0, 3.141593), color: "#4a3520", position: [0, 0.54, 0.41], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.06, 0.04, 8), color: "#9bb4c0", position: [0, 0.88, 0.41], rotation: [1.570796, 0, 0] },
    ] },
  ],
  animations: [],
});
